import React from "react";
import { InfoMessage, Shimmer } from "sprint-common-web";

import { useCloudFileDetails } from "../../../../common/useCloudFileDetails";
import { useCloudFilePreviewContext } from "../hooks/useCloudFilePreviewContext";
import { useVideoRekognitionResultContext } from "../rekognition/hooks/useVideoRekognitionResultContext";
import { FileType } from "../types/CloudFilePreviewItem";
import { RekognitionVideoPreview } from "./RekognitionVideoPreview";
import { VideoPreview } from "./VideoPreview";

interface VideoFilePreviewProps {
    manifestUrl?: string;
    showRekognitionPreview?: boolean;
}

export const VideoFilePreview = (props: VideoFilePreviewProps): JSX.Element => {
    const { isPreviewLoading, filePreview } = useCloudFilePreviewContext();
    const { data: cloudFileDetails } = useCloudFileDetails();
    const { showRekognitionPreview } = useVideoRekognitionResultContext();

    if (isPreviewLoading || !cloudFileDetails) {
        return <Shimmer />;
    }

    if (filePreview?.type !== FileType.Video) {
        return <InfoMessage message="Preview for selected file type is not available" />;
    }

    const manifestUrl = props.manifestUrl ?? filePreview.url;

    if (!showRekognitionPreview || props.showRekognitionPreview === false) {
        return <VideoPreview cloudFileId={cloudFileDetails.cloudFileId} manifestUrl={manifestUrl} width="50vw" />;
    }

    return <RekognitionVideoPreview cloudFileId={cloudFileDetails.cloudFileId} manifestUrl={manifestUrl} />;
};
